export const UPDATE_ACTIVE_LINK = content => ({
    type: "UPDATE_ACTIVE_LINK",
    payload: content
});